export const findServiceEntry = (serviceTypes, service) =>
  serviceTypes
    .find(type => String(type.id) === String(service.tipo))
    ?.services.find(
      item => String(item.id) === String(service.servicoDetalhado)
    );

export const validateNucleoWorkOrderRequest = ({
  configured,
  form,
  serviceTypes,
  t,
}) => {
  const errors = {};
  if (!configured)
    errors.catalog = t('NUCLEO_WORK_ORDERS.REQUEST.ERRORS.CATALOG');
  if (!form.servico.length)
    errors.services = t('NUCLEO_WORK_ORDERS.REQUEST.ERRORS.SERVICES');

  form.servico.forEach((service, index) => {
    if (!service.tipo || !service.servicoDetalhado)
      errors[`service_${index}`] = t(
        'NUCLEO_WORK_ORDERS.REQUEST.ERRORS.SERVICE'
      );
    if (
      findServiceEntry(serviceTypes, service)?.context?.required &&
      !service.valorServicoDetalhado
    ) {
      errors[`context_${index}`] = t(
        'NUCLEO_WORK_ORDERS.REQUEST.ERRORS.CONTEXT'
      );
    }
  });

  if (!['0', '1'].includes(form.onus_solicitada))
    errors.onus = t('NUCLEO_WORK_ORDERS.REQUEST.ERRORS.REQUIRED');
  if (form.onus_solicitada === '0' && !form.justificativa_onus.trim()) {
    errors.onus_reason = t('NUCLEO_WORK_ORDERS.REQUEST.ERRORS.REQUIRED');
  }
  if (!['0', '1'].includes(form.vendedor_comarca))
    errors.district = t('NUCLEO_WORK_ORDERS.REQUEST.ERRORS.REQUIRED');
  if (form.vendedor_comarca === '1' && !form.vendedores_comarca.length) {
    errors.district_rows = t('NUCLEO_WORK_ORDERS.REQUEST.ERRORS.DISTRICT');
  }
  form.vendedores_comarca.forEach((row, index) => {
    if (!row.vendedor || !row.estado)
      errors[`district_${index}`] = t(
        'NUCLEO_WORK_ORDERS.REQUEST.ERRORS.DISTRICT_ROW'
      );
  });

  return errors;
};
